import {ModelsResponseReader} from "@kaspernj/api-maker"

export default async function currentWorkplace() {
  const currentWorkplaceResponse = await Workplace.current()
  const currentWorkplace = ModelsResponseReader.first(digg(currentWorkplaceResponse, "current"))

  return currentWorkplace
}
